import { Directive, DirectiveBinding } from 'vue'

interface ExtendedHTMLElement extends HTMLElement {
  clickOutsideEvent?: (_event: MouseEvent) => void
  mousedownOutsideEvent?: (_event: MouseEvent) => void
  wheelOutsideEvent?: (_event: MouseEvent) => void
}

const getDirective = (eventType: 'click' | 'mousedown' | 'wheel'): Directive => {
  const eventKey = eventType === 'mousedown' ? 'mousedownOutsideEvent' : eventType === 'click' ? 'clickOutsideEvent' : 'wheelOutsideEvent'

  return {
    beforeMount(element: ExtendedHTMLElement, binding: DirectiveBinding) {
      const eventHandler = (e: MouseEvent) => {
        // if (e.button === 0 && element !== e.target && !element.contains(e.target as Node)) {
        if (element !== e.target && !element.contains(e.target as Node)) {
          if (typeof binding.value === 'function') {
            binding.value(e)
          } else {
            console.error(`v-${eventType}-outside is expecting a function. received`, binding)
          }
        }
      }

      element[eventKey] = eventHandler

      document.addEventListener(eventType, eventHandler)
    },
    unmounted(el: ExtendedHTMLElement) {
      document.removeEventListener(eventType, el[eventKey] as EventListener)
    },
  }
}

const ClickOutsideDirective = getDirective('click')
const MousedownOutsideDirective = getDirective('mousedown')
const WheelOutsideDirective = getDirective('wheel')

export { ClickOutsideDirective, MousedownOutsideDirective, WheelOutsideDirective }
